import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_OWNERSHIP_TYPE = createActionTypes('FETCH_OWNERSHIP_TYPE');
export const GET_OWNERSHIP_TYPE = createActionTypes('GET_OWNERSHIP_TYPE_MAKE');
export const CREATE_OWNERSHIP_TYPE = createActionTypes('CREATE_OWNERSHIP_TYPE');
export const UPDATE_OWNERSHIP_TYPE = createActionTypes('UPDATE_OWNERSHIP_TYPE');
export const DELETE_OWNERSHIP_TYPE = createActionTypes('DELETE_OWNERSHIP_TYPE');
